export const INITIAL_STATE_WALLET_INITIALIZED = {
  account: {
    address:
      '0x79030d1b21111111111111111111111111111111111111112807c88da8787a2',
    privateKey:
      '22e80111111111111111111111111111111111111111111111111111113ecec5a',
    publicKey:
      '4b2111111111111111111111111111111111111111111111111111111111116ef',
  },
};
